// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.comments-stack {
    width: 90%;
    margin-left: 5%;
    gap: 2rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/comments/Comments.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,eAAe;IACf,SAAS;AACb","sourcesContent":[".comments-stack {\n    width: 90%;\n    margin-left: 5%;\n    gap: 2rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
